import React from 'react';
import { Field, useFormikContext } from 'formik';
import styled from 'styled-components';
import TextInputField from './TextInputField';
import { ChevronDown } from '../../shared/DesignSystem/Icons';
import { translate } from 'translations/i18n';

const HowHeardDetailsView = styled.div`
  margin-top: 16px;
`;
const IconWrapper = styled.div`
  margin-right: 6px;
`;

const HowHeard = () => {
  const { values } = useFormikContext();
  const howHeardOptions = [
    {
      label: translate('heard.select'),
      value: '',
      disabled: true,
    },
    {
      label: translate('heard.manufacturer'),
      detailQuestion: translate('heard.detail.manufacturer'),
      value: 'Manufacturer or Industry Group',
    },
    {
      label: translate('heard.podcast'),
      detailQuestion: translate('heard.detail.which'),
      value: 'Podcast',
    },
    {
      label: translate('heard.social'),
      detailQuestion: translate('heard.detail.social'),
      value: 'Social Media or Search',
    },
    {
      label: translate('heard.softwareIntegrationPartner'),
      detailQuestion: translate('heard.detail.which'),
      value: 'Software Integration Partner',
    },
    {
      label: translate('heard.someone'),
      detailQuestion: translate('heard.detail.someone'),
      value: 'Someone told me',
    },
    {
      label: translate('heard.tradeShow'),
      detailQuestion: translate('heard.detail.tradeShow'),
      value: 'Trade Show or Event',
    },
    {
      label: translate('heard.other'),
      detailQuestion: translate('heard.detail.manufacturer'),
      value: 'Other',
    },
  ];

  const howHeardDetailQuestion =
    values.howHeardType &&
    howHeardOptions.find((option) => option.label === values.howHeardType)
      ?.detailQuestion;

  return (
    <div className="form-field">
      <div className="input-wrap ">
        <div className="input-wrap input-wrap--withicon">
          <Field
            as="select"
            name="howHeardType"
            className="select-new-signup"
            data-testid="signup__howHeard"
          >
            {howHeardOptions.map((option) => (
              <option
                key={option.label}
                value={option.value}
                disabled={option.disabled}
                data-testid={`signup__howHeard-${option.label}`}
              >
                {option.label}
              </option>
            ))}
          </Field>
          <label htmlFor="howHeard">
            {translate('heard.label')}
          </label>
          <IconWrapper>
            <ChevronDown size={20} color="#707B86" />
          </IconWrapper>
        </div>
        {values.howHeardType ? (
          <HowHeardDetailsView>
            <TextInputField
              showClearIcon
              name="howHeardDetail"
              type="text"
              placeholder={howHeardDetailQuestion}
            />
          </HowHeardDetailsView>
        ) : null}
      </div>
    </div>
  );
};

export default HowHeard;
